import React, { FC } from 'react';
import styles from './nav.module.scss';

type Props = {
  dataTestId: string;
};

export const Nav: FC<Props> = ({ dataTestId, children }) => (
  <div className={styles.container} data-test-id={dataTestId}>
    {children}
  </div>
);
